const productImagesAlt = document.querySelectorAll('.product-image--alt__item');

const slideChangeFunc = (index) => {
  const productActiveImageAlt = document.querySelector('.product-image--alt__item.is-active');
  const count = document.querySelector('.js-count');
  count && (count.innerHTML = index + 1);
  if (productActiveImageAlt) {
    productActiveImageAlt.classList.remove('is-active');
    if (productImagesAlt[index]) {
      productImagesAlt[index].classList.add('is-active');
    }
  } else {
    if (productImagesAlt[index]) {
      productImagesAlt[index].classList.add('is-active');
    }
  }
};

const productImageSlider = new Swiper('.product-image__container', {
  loop: true,
  slidesPerView: 1,
  effect: 'fade',
  speed: 1000,
  navigation: {
    nextEl: '.product-image__next',
    prevEl: '.product-image__prev',
  },
  on: {
    slideChange: (swiper) => {
      slideChangeFunc(swiper.realIndex);
    },
  },
});

// PCでカラー選択時の処理
const colorSelectorItems = document.querySelectorAll('.color-selector__item');
colorSelectorItems.forEach((item) => {
  const imagePosition = item.dataset.position;
  item.addEventListener('click', () => {
    productImageSlider.slideTo(Number(imagePosition));
  });
});
